<template>
    <div class="mls-declaimer-container" :class="theme" >
        <div class="declaimer" v-for="mls in mlsOrgs" :key="mls.id">
            <div class="mls-logo" v-if="mls.logo">
                <site-img alt="mls logo" class="logo" :src="mls.logo" type="bgImg" backSize="contain" backPos="left"></site-img>
            </div>
            <div v-if="mls.declaimer" class="content" :class="declaimerCls" v-html="mls.declaimer"></div>
        </div>
    </div>
</template>

<script>
import com from './mls-disclaimer.js'

export default {
    ...com
}

</script>

<style lang="scss">
@import './index.scss';
.mls-declaimer-container {
    color: #787878;
    font-size: 13px;
    line-height: 150%;
    padding-top: 30px;
    @media (max-width: 600px) {
        padding-top: 20px;
    }
    .declaimer {
        .mls-logo {
            margin-bottom: 10px;
            .logo {
                height: 40px;
                width: 100%;
            }
        }
        .content:first-child{
            margin-top: 0;
        }
    }
    .declaimer+.declaimer{
        margin-top: 30px;
    }
    @media (max-width: 600px) {
        .declaimer+.declaimer{
            margin-top: 20px;
        }
    }
    &.standard {
        color: #a0a3af;
    }
    &.fashion {
        color: #8195bd;
    }
}
</style>
